(function(){
    var now = new Date();
    var version = now.getFullYear().toString() + "0" + now.getMonth() + "0" + now.getDate() +
        "0" + now.getHours();
    var head = document.getElementsByTagName("head")[0];
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://app.najva.com/static/css/local-messaging.css" + "?v=" + version;
    head.appendChild(link);
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://app.najva.com/static/js/scripts/kishoto-website-27628-6b18a545-5115-4558-ac99-499abf533e4d.js" + "?v=" + version;
    head.appendChild(script);
})()